import { generatePath, useHistory } from 'react-router-dom'
import { InformalFeedbackRequest, SubmittedInformalFeedbackReview } from 'api/clients/InformalFeedbackRequestsClient'
import { KeyActionButton } from './KeyActionButton'
import { DESIGN_PATH, DOC_PATH } from 'paths'

export interface RequestAnotherReviewButtonProps {
  review: SubmittedInformalFeedbackReview
  request: InformalFeedbackRequest
}

export const RequestAnotherReviewButton = ({ request, review }: RequestAnotherReviewButtonProps) => {
  const history = useHistory()

  return (
    <KeyActionButton
      reviewType={request.type}
      label="Request again"
      onPress={() => {
        if (request.article) {
          history.push({
            pathname: generatePath(DOC_PATH, { slug: request.article.slug }),
            search: 'requestAnotherReview=true',
          })
        } else {
          history.push({
            pathname: generatePath(DESIGN_PATH, { key: request.design.key }),
            search: 'requestAnotherReview=true',
          })
        }
      }}
    />
  )
}
